module.exports = __webpack_public_path__ + "static/media/search.40139a39.svg";